import {
  DatabaseOutlined,
  ApartmentOutlined,
  AimOutlined,
  TrophyOutlined,
} from '@ant-design/icons';

const master = {
  id: 'group-master',
  title: 'Master',
  type: 'group',
  children: [
    {
      id: 'master-collapse',
      title: 'Master',
      type: 'collapse',
      icon: DatabaseOutlined,
      children: [
        { id: 'master-category', title: 'Category', type: 'item', url: '/master/category', icon: ApartmentOutlined },
        { id: 'master-goal', title: 'Goal Type', type: 'item', url: '/master/goal', icon: AimOutlined },
        { id: 'master-badge', title: 'Badge', type: 'item', url: '/master/badge', icon: TrophyOutlined },
      ]
    },
  ]
};

export default master;
